import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import Modal from 'react-modal';

import './preferences.scss';

import { ModalWindow, Button } from '../../atoms';
import { DashNav, DashContainer, PreferencesContainer,DashContentFooter } from '../../molecules';
import { DashboardContext, UserContext, PreferencesContext } from '../../../context';
import { AuthService } from '../../../services';
import { default as t } from '../../../utils/i18n';

function Preferences () {
  Modal.setAppElement('#root');
  const history = useHistory();

  const [dashData, setDashData] = useState({});
  const [showSignedOutModal, setShowSignedOutModal] = useState(false);

  const { user, setUser } = useContext(UserContext);

  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const refreshToken = user?.tokens?.refreshToken;
  const username = user?.username;
  const authenticated = user?.authenticated || false;

  useEffect(() => {
    async function verifyTheSession () {
      ////console.log('Verifying the access token...');
      try {
        await AuthService.verifySession(username.toLowerCase(), userAccessToken);
      } catch (error) {
        const dataCode = error?.data?.data?.code;
        ////console.log('Error while verifying the access token...', dataCode);
        if (dataCode === 'CL_USR_009' || dataCode === 'CL_USR_000' || dataCode === 'CL_USR_007') {
          setUser(prevUserState => ({
            ...prevUserState,
            authenticated: false,
          }));
          setShowSignedOutModal(true);
        }
      }
    }
    verifyTheSession();

    async function refreshTheToken () {
      ////console.log('Refreshing the tokens...');

      try {
        const refreshTokenResponse = await AuthService.refreshSession(
          username.toLowerCase(),
          refreshToken
        );
        const tokens = refreshTokenResponse.data?.data;
        setUser(prevUserState => ({
          ...prevUserState,
          tokens,
          authenticated: true,
        }));
      } catch (error) {
        const dataCode = error?.data?.data?.code;
        ////console.log(dataCode);
        if (dataCode === 'CL_USR_009' || dataCode === 'CL_USR_000' || dataCode === 'CL_USR_007') {
          setShowSignedOutModal(true);
        }
      }
    }
    const refreshInterval = setInterval(refreshTheToken, 600000);

    return () => {
      clearInterval(refreshInterval);
    };
  }, [authenticated]);

  useEffect(() => {
    document.body.style.backgroundColor = '#ffffff';
  });

  useEffect(() => {
    ////console.log('dash data updated: ', JSON.stringify(dashData));
  }, [dashData]);

  const handleOnReload = () => {
    localStorage.removeItem('user');
    setUser(null);
    history.push('/signIn');
  };

  return (
    <DashboardContext.Provider value={{ dashData, setDashData }}>
      <div className='row no-gutters'>
        <div className='no-gutters dash-left-wrapper'>
          <DashNav viewContext='preferences' />
        </div>
        <div className='no-gutters dash-right-wrapper'>
          <section className='right-section'>
            <PreferencesContainer />
            <DashContentFooter />
          </section>
        </div>
      </div>
      <ModalWindow className='fqa-modal--notification' isOpen={false} heading='Warning'>
        <h3 className='fqa-model-dash--message'>
          {t('pref.unsaved.changes.header')}{' '}
        </h3>
        <div className='fqa-model-dash--actions'>
          <Button
            className='fqa-model-dash--actions-reload'
            label='Yes'
            handleClick={handleOnReload}
          />
          <Button
            className='fqa-model-dash--actions-reload'
            label='No'
            handleClick={handleOnReload}
          />
        </div>
      </ModalWindow>
    </DashboardContext.Provider>
  );
}

export default Preferences;
